/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Device_Change_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to change audio device: {error}" |
*
* @param {Audio_Recorder_Device_Change_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_device_change_failed = /** @type {((inputs: Audio_Recorder_Device_Change_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Device_Change_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec du changement de périphérique audio : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audiogerät konnte nicht gewechselt werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile modificare il dispositivo audio: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось изменить аудиоустройство: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo cambiar el dispositivo de audio: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`更改音频设备失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`オーディオデバイスの変更に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो डिवाइस बदलने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao alterar o dispositivo de áudio: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to change audio device: ${i?.error}`)
});